import React, { useContext } from "react";
import { FeatureAccessContext } from "../../../context/featureAccess";

export const useWorkspace = () => {
  const { selectedWorkspace } = useContext(FeatureAccessContext);
  return { workspace: selectedWorkspace };
};
